{
  "instances": {
    "liquibase": {
      "label": "Liquibase",
      "author": "작성자",
      "changelog": "변경이력",
      "checksum": "체크섬",
      "comments": "코멘트",
      "contexts": "컨텍스트",
      "deployment_id": "배포 Id",
      "description": "비고",
      "execution": "실행",
      "execution_date": "실행 일시",
      "execution_order": "실행 순서",

      "id": "아이디",
      "labels": "라벨",
      "tag": "태그"
    }
  }
}
